import { CircleSkeleton, InputSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';
import PhoneNumberLoading from '@/_containers/inputs/phone-number/loading';

export default function Loading({ isModal = false }: { isModal?: boolean }) {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={1} isModal={isModal} />

      <Container>
        <LeftSection forceFullWidth={isModal}>
          <CardContainer bodyClassName="flex items-start gap-6 sm:items-end">
            <section>
              <CircleSkeleton className="size-28" />
            </section>
            <FormLayout className="mt-0 flex-1 gap-y-4 sm:pb-6">
              <InputSkeleton className="col-span-12 sm:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-4" />
            </FormLayout>
          </CardContainer>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
            </FormLayout>
          </CardContainer>
          <section className="flex flex-col gap-6 sm:flex-row">
            <CardContainer className="flex-1">
              <SectionHeadingSkeleton />
              <PhoneNumberLoading />
            </CardContainer>
            <CardContainer className="flex-1">
              <SectionHeadingSkeleton />
              <PhoneNumberLoading />
            </CardContainer>
          </section>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
            </FormLayout>
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
